import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Qué recibo al comprar el Kit?',
    a: 'Recibís acceso inmediato a una plataforma con más de 500.000 diseños organizados por categorías, listos para descargar e imprimir. Incluye diseños para: Remeras, Tazas, Almohadones, Stickers Y muchos más productos.'
  }, {
    q: '¿Cuándo me llega?',
    a: 'El acceso es INMEDIATO. Una vez confirmado el pago recibís un correo con tus datos de acceso.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'Todo es 100% digital. Recibís acceso a nuestra nube privada con todos los archivos.'
  }, {
    q: '¿Es físico o digital?',
    a: 'Es un producto 100% DIGITAL. Son archivos para que vos imprimas y estampes.'
  }, {
    q: '¿Necesito ser profesional?',
    a: 'No. El kit está pensado tanto para principiantes como para expertos.'
  }, {
    q: '¿Tengo acceso para siempre?',
    a: 'Sí. El acceso es de por vida con futuras actualizaciones.'
  }, {
    q: '¿Qué hago si no me llega el acceso?',
    a: 'Revisá Spam o Promociones. Si no está, escribinos a soporte y lo solucionamos.'
  }, {
    q: '¿Es una compra segura?',
    a: 'Sí. Utilizamos pasarelas de pago encriptadas y seguras.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-14 md:py-16 bg-[#111827]" data-id="element-52">
      <div className="max-w-[700px] mx-auto px-4" data-id="element-53">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[24px] md:text-[32px] font-black text-center mb-12 uppercase text-white" data-id="element-54">
          Resolvé aquí tus dudas
        </motion.h2>

        <div className="space-y-3" data-id="element-55">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 8
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.04
        }} className="bg-[#1a1f35] border border-white/10 rounded-xl overflow-hidden" data-id="element-56">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-5 py-3.5 flex items-center justify-between text-left focus:outline-none" data-id="element-57">
                <span className="font-bold text-[17px] text-white" data-id="element-58">
                  {faq.q}
                </span>
                <ChevronDown className={`w-4 h-4 text-[#f5a623] transition-transform duration-300 flex-shrink-0 ml-3 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-59" />
              </button>

              <AnimatePresence data-id="element-60">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-61">
                    <div className="px-5 pb-4 text-[15px] text-gray-300 border-t border-white/5 pt-3" data-id="element-62">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}